import { cn } from '@/lib/utils';

/**
 * A textarea component with a class that can be overridden.
 *
 * @example
 * <Textarea />
 *
 * @param props - The props for the textarea element.
 */
export function Textarea({
  className,
  ...props
}: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      {...props}
      className={cn(
        `w-full px-4 py-3 border rounded-lg bg-white border-gray-300
         focus:border-blue-500 focus:outline-none transition-all duration-200`,
        className
      )}
    />
  );
}
